import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "hidden 2xl:block overflow-x-auto" }
const _hoisted_2 = { class: "min-w-full divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_3 = { class: "bg-white dark:bg-black divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_4 = { class: "px-3 sm:px-2 py-4 whitespace-nowrap text-sm max-w-xs lg:max-w-sm text-gray-900 dark:text-white text-center" }
const _hoisted_5 = { class: "text-xs sm:text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_6 = { class: "px-3 sm:px-2 py-4 text-sm max-w-xs lg:max-w-sm text-center" }
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "px-3 sm:px-2 py-4 whitespace-nowrap text-sm text-center" }
const _hoisted_9 = { class: "px-3 sm:px-2 py-4 whitespace-nowrap text-center" }
const _hoisted_10 = { class: "px-3 sm:px-2 py-4 text-sm max-w-xs lg:max-w-sm text-center" }
const _hoisted_11 = { class: "text-xs sm:text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_12 = { class: "px-3 sm:px-2 py-4 text-sm max-w-xs lg:max-w-sm text-center" }
const _hoisted_13 = { class: "text-xs sm:text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_14 = { class: "px-3 sm:px-2 py-4 whitespace-nowrap text-center" }
const _hoisted_15 = { class: "px-3 sm:px-2 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400 text-center" }
const _hoisted_16 = { class: "flex items-center justify-center space-x-1 lg:space-x-2" }
const _hoisted_17 = { class: "relative group inline-block" }
const _hoisted_18 = ["onClick", "disabled"]
const _hoisted_19 = { class: "relative group inline-block" }
const _hoisted_20 = ["onClick", "disabled"]
const _hoisted_21 = { class: "relative group inline-block" }
const _hoisted_22 = ["onClick", "disabled"]
const _hoisted_23 = { class: "relative group inline-block" }
const _hoisted_24 = ["onClick", "disabled"]
const _hoisted_25 = { class: "relative group inline-block" }
const _hoisted_26 = ["onClick", "disabled"]
const _hoisted_27 = { class: "relative group inline-block" }
const _hoisted_28 = ["onClick", "disabled"]
const _hoisted_29 = { class: "2xl:hidden divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_30 = { class: "flex items-center justify-between mb-3" }
const _hoisted_31 = { class: "flex items-center space-x-2" }
const _hoisted_32 = { class: "text-sm font-medium text-gray-900 dark:text-white" }
const _hoisted_33 = { class: "mb-3" }
const _hoisted_34 = { class: "text-sm text-gray-600 dark:text-gray-400 break-words" }
const _hoisted_35 = { class: "mb-3" }
const _hoisted_36 = { class: "mb-3" }
const _hoisted_37 = { class: "mb-3 grid grid-cols-2 gap-3" }
const _hoisted_38 = { class: "text-sm text-gray-600 dark:text-gray-400" }
const _hoisted_39 = { class: "text-sm text-gray-600 dark:text-gray-400" }
const _hoisted_40 = { class: "flex flex-wrap gap-2 pt-3 border-t border-gray-100 dark:border-gray-700" }
const _hoisted_41 = ["onClick", "disabled"]
const _hoisted_42 = ["onClick", "disabled"]
const _hoisted_43 = ["onClick", "disabled"]
const _hoisted_44 = ["onClick", "disabled"]
const _hoisted_45 = ["onClick", "disabled"]
const _hoisted_46 = ["onClick", "disabled"]

import type { Customer } from '@/types/customer';
import ViewIcon from '@/components/icons/ViewIcon.vue';
import EditIcon from '@/components/icons/EditIcon.vue';
import DeleteIcon from '@/components/icons/DeleteIcon.vue';
import LockIcon from '@/components/icons/LockIcon.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerTable',
  props: {
    customers: {},
    loading: { type: Boolean }
  },
  emits: ["view", "edit", "reset-password", "delete", "update-category", "remarks"],
  setup(__props: any) {





function getStatusClass(status: string): string {
  switch (status) {
    case 'active':
      return 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-400';
    case 'pending':
      return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-400';
    case 'rejected':
      return 'bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-400';
    default:
      return 'bg-gray-100 text-gray-800 dark:bg-black/20 dark:text-gray-400';
  }
}

function getStatusDotClass(status: string): string {
  switch (status) {
    case 'active':
      return 'bg-green-400';
    case 'pending':
      return 'bg-yellow-400';
    case 'rejected':
      return 'bg-red-400';
    default:
      return 'bg-gray-400';
  }
}

function getBrandClass(brandName: string | undefined): string {
  switch (brandName?.toLowerCase()) {
    case 'continental':
      return 'bg-orange-100 text-orange-800 dark:bg-orange-900/20 dark:text-orange-400';
    case 'falken':
      return 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-400';
    default:
      return 'bg-gray-100 text-gray-800 dark:bg-black/20 dark:text-gray-400';
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _cache[8] || (_cache[8] = _createElementVNode("thead", { class: "bg-gray-50 dark:bg-black" }, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", {
              scope: "col",
              class: "px-3 sm:px-6 py-4 text-center text-xs font-bold text-slate-800 dark:text-gray-400 uppercase tracking-wider"
            }, " Customer "),
            _createElementVNode("th", {
              scope: "col",
              class: "px-3 sm:px-6 py-4 text-center text-xs font-bold text-slate-800 dark:text-gray-400 uppercase tracking-wider"
            }, " Email "),
            _createElementVNode("th", {
              scope: "col",
              class: "px-3 sm:px-6 py-4 text-center text-xs font-bold text-slate-800 dark:text-gray-400 uppercase tracking-wider"
            }, " Brand "),
            _createElementVNode("th", {
              scope: "col",
              class: "px-3 sm:px-6 py-4 text-center text-xs font-bold text-slate-800 dark:text-gray-400 uppercase tracking-wider"
            }, " Category "),
            _createElementVNode("th", {
              scope: "col",
              class: "px-3 sm:px-6 py-4 text-center text-xs font-bold text-slate-800 dark:text-gray-400 uppercase tracking-wider"
            }, " Vehicles "),
            _createElementVNode("th", {
              scope: "col",
              class: "px-3 sm:px-6 py-4 text-center text-xs font-bold text-slate-800 dark:text-gray-400 uppercase tracking-wider"
            }, " Tires "),
            _createElementVNode("th", {
              scope: "col",
              class: "px-3 sm:px-6 py-4 text-center text-xs font-bold text-slate-800 dark:text-gray-400 uppercase tracking-wider"
            }, " Status "),
            _createElementVNode("th", {
              scope: "col",
              class: "px-3 sm:px-6 py-4 text-center text-xs font-bold text-slate-800 dark:text-gray-400 uppercase tracking-wider"
            }, " Actions ")
          ])
        ], -1)),
        _createElementVNode("tbody", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customers, (customer) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: customer.user_id,
              class: "transition-colors duration-150 hover:bg-gray-50 dark:hover:bg-gray-600 odd:bg-white even:bg-gray-25 dark:odd:bg-gray-900 dark:even:bg-gray-800"
            }, [
              _createElementVNode("td", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(customer.first_name) + " " + _toDisplayString(customer.last_name), 1)
              ]),
              _createElementVNode("td", _hoisted_6, [
                _createElementVNode("div", {
                  class: "truncate text-xs sm:text-sm text-gray-500 dark:text-gray-400",
                  title: customer.email
                }, _toDisplayString(customer.email), 9, _hoisted_7)
              ]),
              _createElementVNode("td", _hoisted_8, [
                _createElementVNode("span", {
                  class: _normalizeClass(["inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium", getBrandClass(customer.brand?.brand_name)])
                }, _toDisplayString(customer.brand?.brand_name || 'N/A'), 3)
              ]),
              _createElementVNode("td", _hoisted_9, [
                _createElementVNode("span", {
                  class: _normalizeClass(["inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium", customer.category === 'internal'
                  ? 'bg-amber-100 text-amber-800 dark:bg-amber-900/20 dark:text-amber-400'
                  : 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-400'])
                }, _toDisplayString(customer.category === 'internal' ? 'Internal' : 'Customer'), 3)
              ]),
              _createElementVNode("td", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(customer.vehicles_count || 0), 1)
              ]),
              _createElementVNode("td", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(customer.tires_count || 0), 1)
              ]),
              _createElementVNode("td", _hoisted_14, [
                _createElementVNode("span", {
                  class: _normalizeClass(["inline-flex items-center px-2 sm:px-2.5 py-1 rounded-full text-xs font-medium", getStatusClass(customer.status)])
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["w-1.5 h-1.5 rounded-full mr-1 sm:mr-1.5", getStatusDotClass(customer.status)])
                  }, null, 2),
                  _createTextVNode(" " + _toDisplayString(customer.status), 1)
                ], 2)
              ]),
              _createElementVNode("td", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("button", {
                      onClick: _withModifiers(($event: any) => (_ctx.$emit('view', customer)), ["stop"]),
                      disabled: _ctx.loading,
                      class: "inline-flex items-center p-1.5 border border-transparent rounded-md text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
                    }, [
                      _createVNode(ViewIcon, { classes: "h-5 w-5" })
                    ], 8, _hoisted_18),
                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "absolute bottom-full left-1/2 -translate-x-1/2 mb-1 w-max text-xs text-white bg-gray-800 px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition pointer-events-none z-10" }, " View Details ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("button", {
                      onClick: _withModifiers(($event: any) => (_ctx.$emit('edit', customer)), ["stop"]),
                      disabled: _ctx.loading,
                      class: "inline-flex items-center p-1.5 border border-transparent rounded-md text-amber-600 dark:text-amber-400 hover:bg-amber-50 dark:hover:bg-amber-900/20 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
                    }, [
                      _createVNode(EditIcon, { classes: "h-5 w-5" })
                    ], 8, _hoisted_20),
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "absolute bottom-full left-1/2 -translate-x-1/2 mb-1 w-max text-xs text-white bg-gray-800 px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition pointer-events-none z-10" }, " Edit Customer ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("button", {
                      onClick: _withModifiers(($event: any) => (_ctx.$emit('reset-password', customer)), ["stop"]),
                      disabled: _ctx.loading,
                      class: "inline-flex items-center p-1.5 border border-transparent rounded-md text-purple-600 dark:text-purple-400 hover:bg-purple-50 dark:hover:bg-purple-900/20 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
                    }, [
                      _createVNode(LockIcon, { classes: "h-5 w-5" })
                    ], 8, _hoisted_22),
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "absolute bottom-full left-1/2 -translate-x-1/2 mb-1 w-max text-xs text-white bg-gray-800 px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition pointer-events-none z-10" }, " Reset Password ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("button", {
                      onClick: _withModifiers(($event: any) => (_ctx.$emit('delete', customer)), ["stop"]),
                      disabled: _ctx.loading,
                      class: "inline-flex items-center p-1.5 border border-transparent rounded-md text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
                    }, [
                      _createVNode(DeleteIcon, { classes: "h-5 w-5" })
                    ], 8, _hoisted_24),
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "absolute bottom-full left-1/2 -translate-x-1/2 mb-1 w-max text-xs text-white bg-gray-800 px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition pointer-events-none z-10" }, " Delete Customer ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("button", {
                      onClick: _withModifiers(($event: any) => (_ctx.$emit('update-category', customer)), ["stop"]),
                      disabled: _ctx.loading,
                      class: "inline-flex items-center p-1.5 border border-transparent rounded-md text-teal-600 dark:text-teal-400 hover:bg-teal-50 dark:hover:bg-teal-900/20 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
                    }, _cache[4] || (_cache[4] = [
                      _createElementVNode("svg", {
                        class: "h-5 w-5",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                        })
                      ], -1)
                    ]), 8, _hoisted_26),
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "absolute bottom-full left-1/2 -translate-x-1/2 mb-1 w-max text-xs text-white bg-gray-800 px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition pointer-events-none z-10" }, " Update Category ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("button", {
                      onClick: _withModifiers(($event: any) => (_ctx.$emit('remarks', customer)), ["stop"]),
                      disabled: _ctx.loading,
                      class: "inline-flex items-center p-1.5 border border-transparent rounded-md text-indigo-600 dark:text-indigo-400 hover:bg-indigo-50 dark:hover:bg-indigo-900/20 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
                    }, _cache[6] || (_cache[6] = [
                      _createElementVNode("svg", {
                        class: "h-5 w-5",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
                        })
                      ], -1)
                    ]), 8, _hoisted_28),
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "absolute bottom-full left-1/2 -translate-x-1/2 mb-1 w-max text-xs text-white bg-gray-800 px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition pointer-events-none z-10" }, " Remarks ", -1))
                  ])
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customers, (customer) => {
        return (_openBlock(), _createElementBlock("div", {
          key: customer.user_id,
          class: "p-4 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150"
        }, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("span", _hoisted_32, _toDisplayString(customer.first_name) + " " + _toDisplayString(customer.last_name), 1)
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium", getStatusClass(customer.status)])
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["w-1.5 h-1.5 rounded-full mr-1.5", getStatusDotClass(customer.status)])
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(customer.status), 1)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-sm font-medium text-gray-900 dark:text-white mb-1" }, " Email: ", -1)),
            _createElementVNode("div", _hoisted_34, _toDisplayString(customer.email), 1)
          ]),
          _createElementVNode("div", _hoisted_35, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-sm font-medium text-gray-900 dark:text-white mb-1" }, " Brand: ", -1)),
            _createElementVNode("div", null, [
              _createElementVNode("span", {
                class: _normalizeClass(["inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium", getBrandClass(customer.brand?.brand_name)])
              }, _toDisplayString(customer.brand?.brand_name || 'N/A'), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-sm font-medium text-gray-900 dark:text-white mb-1" }, " Category: ", -1)),
            _createElementVNode("div", null, [
              _createElementVNode("span", {
                class: _normalizeClass(["inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium", customer.category === 'internal'
                ? 'bg-amber-100 text-amber-800 dark:bg-amber-900/20 dark:text-amber-400'
                : 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-400'])
              }, _toDisplayString(customer.category === 'internal' ? 'Internal' : 'Customer'), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", null, [
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-sm font-medium text-gray-900 dark:text-white mb-1" }, " Vehicles: ", -1)),
              _createElementVNode("div", _hoisted_38, _toDisplayString(customer.vehicles_count || 0), 1)
            ]),
            _createElementVNode("div", null, [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-sm font-medium text-gray-900 dark:text-white mb-1" }, " Tires: ", -1)),
              _createElementVNode("div", _hoisted_39, _toDisplayString(customer.tires_count || 0), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("button", {
              onClick: ($event: any) => (_ctx.$emit('view', customer)),
              disabled: _ctx.loading,
              class: "flex-1 inline-flex items-center justify-center px-3 py-2 text-xs font-medium text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20 rounded-lg transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
            }, [
              _createVNode(ViewIcon, { classes: "h-4 w-4 mr-1" }),
              _cache[14] || (_cache[14] = _createTextVNode(" View "))
            ], 8, _hoisted_41),
            _createElementVNode("button", {
              onClick: ($event: any) => (_ctx.$emit('edit', customer)),
              disabled: _ctx.loading,
              class: "flex-1 inline-flex items-center justify-center px-3 py-2 text-xs font-medium text-amber-600 dark:text-amber-400 hover:bg-amber-50 dark:hover:bg-amber-900/20 rounded-lg transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
            }, [
              _createVNode(EditIcon, { classes: "h-4 w-4 mr-1" }),
              _cache[15] || (_cache[15] = _createTextVNode(" Edit "))
            ], 8, _hoisted_42),
            _createElementVNode("button", {
              onClick: ($event: any) => (_ctx.$emit('reset-password', customer)),
              disabled: _ctx.loading,
              class: "flex-1 inline-flex items-center justify-center px-3 py-2 text-xs font-medium text-purple-600 dark:text-purple-400 hover:bg-purple-50 dark:hover:bg-purple-900/20 rounded-lg transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
            }, [
              _createVNode(LockIcon, { classes: "h-4 w-4 mr-1" }),
              _cache[16] || (_cache[16] = _createTextVNode(" Reset "))
            ], 8, _hoisted_43),
            _createElementVNode("button", {
              onClick: ($event: any) => (_ctx.$emit('delete', customer)),
              disabled: _ctx.loading,
              class: "flex-1 inline-flex items-center justify-center px-3 py-2 text-xs font-medium text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
            }, [
              _createVNode(DeleteIcon, { classes: "h-4 w-4 mr-1" }),
              _cache[17] || (_cache[17] = _createTextVNode(" Delete "))
            ], 8, _hoisted_44),
            _createElementVNode("button", {
              onClick: ($event: any) => (_ctx.$emit('update-category', customer)),
              disabled: _ctx.loading,
              class: "flex-1 inline-flex items-center justify-center px-3 py-2 text-xs font-medium text-teal-600 dark:text-teal-400 hover:bg-teal-50 dark:hover:bg-teal-900/20 rounded-lg transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
            }, _cache[18] || (_cache[18] = [
              _createElementVNode("svg", {
                class: "h-4 w-4 mr-1",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                })
              ], -1),
              _createTextVNode(" Category ")
            ]), 8, _hoisted_45),
            _createElementVNode("button", {
              onClick: ($event: any) => (_ctx.$emit('remarks', customer)),
              disabled: _ctx.loading,
              class: "flex-1 inline-flex items-center justify-center px-3 py-2 text-xs font-medium text-indigo-600 dark:text-indigo-400 hover:bg-indigo-50 dark:hover:bg-indigo-900/20 rounded-lg transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
            }, _cache[19] || (_cache[19] = [
              _createElementVNode("svg", {
                class: "h-4 w-4 mr-1",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
                })
              ], -1),
              _createTextVNode(" Remarks ")
            ]), 8, _hoisted_46)
          ])
        ]))
      }), 128))
    ])
  ], 64))
}
}

})